import _ from '@lodash';
import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import VizsgaFeladatsorTableService from '../service/VizsgaFeladatsorTableService';
import TableToolbarPermutationButton from '../component/TableToolbarPermurationButton';
import TableToolbarLockButton from '../component/TableToolbarLockButton';
import TableRowVizsgaFeladatButton from '../component/TableRowVizsgaFeladatButton';
import TableRowVizsgaExportButton from '../component/TableRowVizsgaExportButton';
import TableRowVizsgaKulcsButton from '../component/TableRowVizsgaKulcsButton';
import TableToolbarRecalculateButton from '../component/TableToolbarRecalculateButton';

const myConfig = data => {
	return {
		key: 'vizsgaFeladatsorTable',
		text: 'Vizsgafeladatsor',
		textKey: 'vizsgaFeladatsor',
		service: VizsgaFeladatsorTableService,
		editFormState: item => `/vizsga-feladatsor/edit/${item ? item.id : 'new'}`,
		toolbarAction: ['filter', 'search', 'refresh'],
		toolbarActionList: [
			{
				text: 'Feladatok felvitele',
				icon: 'add',
				action: () => {
					const vizsgaVizsgasor = data.filterList.find(item => item.propertyName === 'vizsgaVizsgasor');
					if (!_.isUndefined(vizsgaVizsgasor)) {
						data.history.push(`/vizsga-feladatsor/edit/new/${vizsgaVizsgasor.value}`);
					} else {
						data.dispatch(showMessage({ message: 'Kérem válasszon ki egy vizsgasort a szűrők között.' }));
					}
				}
			},
			{
				component: TableToolbarPermutationButton
			},
			{
				component: TableToolbarLockButton
			},
			{
				component: TableToolbarRecalculateButton
			}
		],
		filterFields: [
			{
				text: 'Vizsgasor',
				propertyName: 'vizsgaVizsgasor',
				propertyType: 'Long',
				type: 'EQ'
			}
		],
		exportData: {
			tooltip: 'DOCX Jelölt',
			link: item => `${nBossConnection.basePath}vizsgaControl/createExamQuestionDOC?examId=${item.vizsgaVizsgasor.id}&marked=true&group=${item.csoport}`
		},
		rowButtonList: [
			{ component: TableRowVizsgaFeladatButton },
			{
				text: 'Megoldókulcs',
				icon: 'insert_drive_file',
				action: item => window.open(`${nBossConnection.basePath}vizsgaControl/createExamPack?group=${item.csoport}&examId=${item.vizsgaVizsgasor.id}&eType=`, '_blank', '')
			},
			{
				text: 'DOCX Jelöletlen',
				icon: 'insert_drive_file',
				action: item => window.open(`${nBossConnection.basePath}vizsgaControl/createExamQuestionDOC?examId=${item.vizsgaVizsgasor.id}&marked=false&group=${item.csoport}`, '_blank', '')
			}
		],
		rowAction: ['exportData', 'delete'],
		columns: [
			{
				key: 'vizsgaVizsgasor.name',
				text: 'Vizsgasor',
				textKey: 'vizsgaVizsgasor.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'csoport',
				text: 'Csoport',
				textKey: 'csoport',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'lockIn',
				text: 'Lezárva?',
				textKey: 'lockIn',
				type: 'boolean',
				sortable: true,
				disablePadding: false
			}
		]
	};
};

function VizsgaFeladatsorTable() {
	const dispatch = useDispatch();
	const history = useHistory();
	const filterList = useSelector(rootState => rootState.vizsgaFeladatsorTable.tableBrowserFilter.filterList);
	const config = myConfig({ filterList, dispatch, history });
	return <TableBrowser config={config} />;
}

export default withReducer('vizsgaFeladatsorTable', reducer('vizsgaFeladatsorTable'))(VizsgaFeladatsorTable);
